import { render, staticRenderFns } from "./OptometristYuFuKuanOut.vue?vue&type=template&id=0ae8d5c0&scoped=true&"
import script from "./OptometristYuFuKuanOut.vue?vue&type=script&lang=js&"
export * from "./OptometristYuFuKuanOut.vue?vue&type=script&lang=js&"
import style0 from "./OptometristYuFuKuanOut.vue?vue&type=style&index=0&id=0ae8d5c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae8d5c0",
  null
  
)

export default component.exports